<h1 mat-dialog-title>Cadastrar Grupo</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 300px;">
    <form [formGroup]="grupoForm">
        <div class="row">
            <div class="col-auto">
                <mat-form-field appearance="outline" [floatLabel]="'always'">
                    <mat-label>Nome do Grupo</mat-label>
                    <input type="text" matInput formControlName="nomeGrupo" required maxlength="50">
                    <mat-error *ngIf="f.nomeGrupo.errors">
                        Campo obrigatório
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>

    <mat-divider></mat-divider>

    <section fxLayout fxLayoutAlign="space-between center" class="mtSection">
        <button mat-flat-button color="warn" (click)="cancelar()">
            <mat-icon>clear</mat-icon> Cancelar
        </button>
        <button mat-flat-button color="primary" (click)="cadastrar()">
            <mat-icon>check</mat-icon> Cadastrar
        </button>
    </section>
</div>